import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environment/environment';

export interface RagChatRequest {
  session_id: string;
  message: string;
  language: string;
  company_id: number;
  knowledge_scope: string;
  document_ids?: string[];
  attachments?: File[];
}

export interface RagChatReference {
  source: string;
  page: number | null;
  link: string | null;
}

export interface RagChatResponse {
  success: boolean;
  data: {
    session_id: string;
    answer: string;
    references?: RagChatReference[];
  };
}

@Injectable({
  providedIn: 'root'
})
export class RagApiService {
  private http = inject(HttpClient);
  private readonly endpoint = `${environment.api.base_url}/rag/chat`;

  chat(request: RagChatRequest): Observable<RagChatResponse> {
    const formData = new FormData();
    formData.append('session_id', request.session_id);
    formData.append('message', request.message);
    formData.append('language', request.language);
    formData.append('company_id', String(request.company_id));
    formData.append('knowledge_scope', request.knowledge_scope);
    request.document_ids?.forEach(id => formData.append('document_ids', id));
    request.attachments?.forEach(file => formData.append('attachments', file));
    return this.http.post<RagChatResponse>(this.endpoint, formData);
  }
}
